import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        email: '',
        accessToken: '',
        isLoaded: false,
        authData: [],
        tabIndex: 0,
        isTableauLogin: false,
        loadCount: 0
    },
    mutations: {
        login(state, sso) {
            state.email = sso.profile.email
            state.accessToken = sso.access_token
        },
        load(state, data) {
            state.authData.splice(0);
            if (data.Omni.length > 0) {
                let omni =
                    {
                        Name: 'OMNI',
                        IsActive: false,
                        Categories: data.Omni,
                        UpdateDateList: data.UpdateDate.filter(function (item) {
                            return item.Type.toLowerCase() == "omni";
                        })
                    };
                state.authData.push(omni);
            }
            if (data.Custom.length > 0) {
                let custom =
                    {
                        Name: 'Self-Service',
                        IsActive: false,
                        Categories: data.Custom,
                        UpdateDateList: data.UpdateDate.filter(function (item) {
                            return item.Type.toLowerCase() == "selfservice";
                        })
                    };
                state.authData.push(custom);
            }
            if (data.OdinPlus.length > 0) {
                let odinplus =
                    {
                        Name: 'ODIN+',
                        IsActive: false,
                        Categories: data.OdinPlus,
                        UpdateDateList: data.UpdateDate.filter(function (item) {
                            return item.Type.toLowerCase() == "odinplusdw";
                        })
                    };
                state.authData.push(odinplus);
            }
            state.authData.map(function (item, i) {
                state.tabIndex === i ? item.IsActive = true : item.IsActive = false
            })
            state.isLoaded = true;
        },
        switchTab(state, index) {
            state.tabIndex = index;
            state.authData.map(function (item, i) {
                index === i ? item.IsActive = true : item.IsActive = false
            })
        },
        switchTag(state, category) {
            category.IsHidden = !category.IsHidden
        },
        tableau_login(state) {
            state.isTableauLogin = true
        },
        delete_workbook(state, workbook_id) {
            var custom = state.authData.filter(function (item) {
                return item.Name == "Self-Service"
            })
            let myCategory = custom[0].Categories[1]
            myCategory.Reports = myCategory.Reports.filter(function (item) {
                return item.ReportId != workbook_id;
            });
        },
        loading(state, loading) {
            state.loadCount = state.loadCount + loading;
            if (state.loadCount > 0) {
                Pace.bar.el.className = "pace pace-active";
            }
            else {
                Pace.bar.el.className = "pace pace-inactive";
            }

        }
    },
    strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/vuex/store.js